(() => {
  const CONFIG = {
     shippingThreshold: Math.round(1999 * Number(window.Shopify?.currency?.rate || 1)),
    giftThreshold: Math.round(3000 * Number(window.Shopify?.currency?.rate || 1)),
    giftVariantIds: [56392242135375, 56345695748431, 56345414467919],
    giftVariantId: Number(localStorage.getItem('cherries_gift_variant_id') || 56392242135375),
    giftProperty: '_cherries_free_gift'
  };

  document.addEventListener('cherries:gift-color-change', (event) => {
    const variantId = Number(event.detail && event.detail.variantId);
    if (CONFIG.giftVariantIds.includes(variantId)) {
      CONFIG.giftVariantId = variantId;
      refresh();
    }
  });

  let syncing = false;
  let refreshTimer;

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'EUR', minimumFractionDigits: 2
  }).format(Math.max(0, cents) / 100);

  const isGrip = (item) => CONFIG.giftVariantIds.includes(Number(item.variant_id));
  const isAutoGift = (item) => isGrip(item) && item.properties && String(item.properties[CONFIG.giftProperty]) === 'true';
  const isDiscountedFreeGrip = (item) => isGrip(item) && Number(item.final_line_price || 0) === 0;
  const qualifyingSubtotal = (cart) => cart.items.reduce((sum, item) => sum + (isAutoGift(item) ? 0 : Number(item.final_line_price || item.line_price || 0)), 0);

  function render(cart) {
    const subtotal = qualifyingSubtotal(cart);
    const progress = Math.min(100, subtotal / CONFIG.giftThreshold * 100);
    const shippingUnlocked = subtotal >= CONFIG.shippingThreshold;
    const giftUnlocked = subtotal >= CONFIG.giftThreshold;

    document.querySelectorAll('[data-cherries-rewards]').forEach((box) => {
      box.querySelector('[data-rewards-fill]').style.width = `${progress}%`;
      box.querySelector('[data-rewards-marker-one]').classList.toggle('is-unlocked', shippingUnlocked);
      box.querySelector('[data-rewards-marker-two]').classList.toggle('is-unlocked', giftUnlocked);
      box.querySelector('[data-rewards-tier-one]').classList.toggle('is-unlocked', shippingUnlocked);
      box.querySelector('[data-rewards-tier-two]').classList.toggle('is-unlocked', giftUnlocked);

      box.querySelector('[data-rewards-message-one]').textContent = shippingUnlocked
        ? 'Welcome Gift unlocked — Free shipping'
        : `Spend ${money(CONFIG.shippingThreshold - subtotal)} more to unlock your Welcome Gift`;

      box.querySelector('[data-rewards-message-two]').textContent = giftUnlocked
        ? 'Signature Gift unlocked — Free Suction Grip added'
        : `Spend ${money(CONFIG.giftThreshold - subtotal)} more to unlock your Signature Gift`;

      box.querySelector('[data-rewards-headline]').textContent = giftUnlocked
        ? 'Both rewards unlocked'
        : shippingUnlocked ? 'One reward unlocked' : 'Unlock your gifts';
    });
  }

  async function getCart() {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  async function refreshVisibleCart() {
    const cartViews = [...document.querySelectorAll('cart-items, cart-drawer-items')];
    const updates = cartViews
      .filter((view) => typeof view.onCartUpdate === 'function')
      .map((view) => view.onCartUpdate());
    if (updates.length) await Promise.allSettled(updates);
  }

  async function syncGift(cart) {
    if (syncing) return cart;
    let cartChanged = false;

    const updates = {};
    const selectedAutoGift = cart.items.find((item) =>
      isAutoGift(item) && Number(item.variant_id) === CONFIG.giftVariantId
    );
    const freeGripToKeep = selectedAutoGift || cart.items.find(isDiscountedFreeGrip);
    const giftKeyToKeep = freeGripToKeep && freeGripToKeep.key;

    cart.items.forEach((item) => {
      const isLegacyProtector = item.properties &&
        String(item.properties._cherries_free_screen_protector) === 'true';

      if (isLegacyProtector) {
        updates[item.key] = 0;
        return;
      }

      if (isDiscountedFreeGrip(item) && item.key !== giftKeyToKeep) {
        updates[item.key] = 0;
        return;
      }

      if (!isAutoGift(item)) return;
      const isSelectedGift = Number(item.variant_id) === CONFIG.giftVariantId;
      if (!isSelectedGift || item.key !== giftKeyToKeep) {
        updates[item.key] = 0;
        return;
      }

      if (Number(item.quantity) !== 1) updates[item.key] = 1;
    });

    if (Object.keys(updates).length) {
      syncing = true;
      try {
        await fetch(window.routes?.cart_update_url || '/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
        cart = await getCart();
        cartChanged = true;
      } finally {
        syncing = false;
      }
    }

    const subtotal = qualifyingSubtotal(cart);
    const gift = cart.items.find((item) => isAutoGift(item) && Number(item.variant_id) === CONFIG.giftVariantId);
    const shouldHaveGift = subtotal >= CONFIG.giftThreshold;
    if ((shouldHaveGift && gift) || (!shouldHaveGift && !gift)) {
      if (cartChanged) await refreshVisibleCart();
      return cart;
    }

    syncing = true;
    try {
      if (shouldHaveGift) {
        await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: CONFIG.giftVariantId, quantity: 1, properties: { [CONFIG.giftProperty]: 'true' } }] })
        });
      } else {
        await fetch(window.routes?.cart_change_url || '/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: gift.key, quantity: 0 })
        });
      }
      const updatedCart = await getCart();
      await refreshVisibleCart();
      document.dispatchEvent(new CustomEvent('cherries:gift-updated'));
      return updatedCart;
    } catch (error) {
      console.warn('[Cherries rewards] Gift sync failed:', error);
      return cart;
    } finally {
      syncing = false;
    }
  }

  async function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      try {
        let cart = await getCart();
        render(cart);
        cart = await syncGift(cart);
        render(cart);
      } catch (error) {
        console.warn('[Cherries rewards] Refresh failed:', error);
      }
    }, 120);
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = String(args[0]?.url || args[0] || '');
    if (!syncing && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) refresh();
    return response;
  };

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cartUpdate', refresh);
  document.addEventListener('cherries:gift-updated', () => setTimeout(refresh, 250));
})();
